import { type Trello } from "../types/trello"

// Tall enough for the customer dropdown, which is capped at a percentage of the
// popup's own height — see components/ComboBox.tsx.
const LINK_POPUP_HEIGHT = 620

/**
 * Opens the customer-link screen.
 *
 * Both entry points — the card button and the card back's Link/Manage button —
 * go through here so the popup can't render at two different sizes depending on
 * which one the user clicked. Pass `mouseEvent` to anchor the popup to the click.
 */
export const openLinkCustomerPopup = (
  t: Trello.PowerUp.IFrame,
  mouseEvent?: MouseEvent
) =>
  t.popup({
    title: "Link customer",
    url: t.signUrl("./link-settings.html"),
    height: LINK_POPUP_HEIGHT,
    mouseEvent,
  })
